// extracted by mini-css-extract-plugin
export default {"ServiceItem":"ServiceItem_ServiceItem__f02sk","ServiceIcon":"ServiceItem_ServiceIcon__wTgli","Label":"ServiceItem_Label__S0eZV"};